import tippy, { roundArrow } from "tippy.js";

(function () {
    "use strict";

    function initTooltips() {
        $(".tooltip").each(function () {
            const title = $(this).attr("title");
            const existingInstance = this._tippy;

            if (existingInstance) {
                if (title !== undefined) {
                    existingInstance.setContent(title);
                    $(this).removeAttr("title");
                }

                return;
            }

            let options = {
                content: title,
            };

            if ($(this).data("trigger") !== undefined) {
                options.trigger = $(this).data("trigger");
            }

            if ($(this).data("placement") !== undefined) {
                options.placement = $(this).data("placement");
            }

            if ($(this).data("theme") !== undefined) {
                options.theme = $(this).data("theme");
            }

            if ($(this).data("tooltip-content") !== undefined) {
                options.content = $($(this).data("tooltip-content"))[0];
            }

            if ($(this).data("allow-html") !== undefined) {
                options.allowHTML = true;
            }

            $(this).removeAttr("title");

            tippy(this, {
                arrow: roundArrow,
                animation: "shift-away",
                ...options,
            });
        });
    }

    initTooltips();

    document.addEventListener("livewire:load", () => {
        Livewire.hook("message.processed", initTooltips);
    });
})();
